module.exports = __webpack_public_path__ + "static/media/logo@2x.a6cefff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo@2x.png
// module id = 324
// module chunks = 0